'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChatMessage } from '@/features/chat/api/types';
import React, { createContext, useContext, useState } from 'react';
interface ChatActionsContextType {
  activeThreadId: string | undefined;
  threadHistory: string[];
  quotedMessageId: string | undefined;
  setQuotedMessageId: (id: string | undefined) => void;
  replyInThread: (messageId: string) => void;
  closeThread: () => void;
  quoteMessage: (messageId: string) => void;
  cancelQuote: () => void;
  highlightedMessageId: string | undefined;
  scrollToMessage: (messageId: string) => void;
  selectedMessage: ChatMessage | undefined;
  setSelectedMessage: (message: ChatMessage | undefined) => void;
}
const ChatActionsContext = createContext<ChatActionsContextType | undefined>(undefined);
export const ChatActionsProvider: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(17);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [threadHistory, setThreadHistory] = useState(t1);
  const [quotedMessageId, setQuotedMessageId] = useState();
  const [highlightedMessageId, setHighlightedMessageId] = useState();
  const [selectedMessage, setSelectedMessage] = useState();
  let t2;
  if ($[1] !== threadHistory) {
    t2 = threadHistory.length > 0 ? threadHistory.at(-1) : undefined;
    $[1] = threadHistory;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const activeThreadId = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = messageId => {
      setThreadHistory(previous => [...previous, messageId]);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const replyInThread = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setThreadHistory(_temp);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const closeThread = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = messageId_0 => {
      setQuotedMessageId(messageId_0);
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const quoteMessage = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setQuotedMessageId(undefined);
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const cancelQuote = t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = messageId_1 => {
      const element = document.querySelector(`#message-${messageId_1}`);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        setHighlightedMessageId(messageId_1);
        setTimeout(() => setHighlightedMessageId(undefined), 2000);
      }
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const scrollToMessage = t7;
  let t8;
  if ($[8] !== activeThreadId || $[9] !== highlightedMessageId || $[10] !== quotedMessageId || $[11] !== selectedMessage || $[12] !== threadHistory) {
    t8 = {
      activeThreadId,
      threadHistory,
      quotedMessageId,
      setQuotedMessageId,
      replyInThread,
      closeThread,
      quoteMessage,
      cancelQuote,
      highlightedMessageId,
      scrollToMessage,
      selectedMessage,
      setSelectedMessage
    };
    $[8] = activeThreadId;
    $[9] = highlightedMessageId;
    $[10] = quotedMessageId;
    $[11] = selectedMessage;
    $[12] = threadHistory;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== children || $[15] !== t8) {
    t9 = <ChatActionsContext.Provider value={t8}>{children}</ChatActionsContext.Provider>;
    $[14] = children;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export const useChatActions = () => {
  const context = useContext(ChatActionsContext);
  if (!context) {
    throw new Error("useChatActions must be used within ChatActionsProvider");
  }
  return context;
};
function _temp(previous_0) {
  return previous_0.slice(0, -1);
}